import '../models/cart/cart-state.js';
import '../models/checkout/checkout-step-error-type.js';
import '../models/checkout-settings.js';
import { ShippingMethod } from '../models/step-shipping/shipping-methods.js';
import '../models/shared.js';

/**
 * Shipping method helpers
 */ const isDelivery = (method)=>method === ShippingMethod.Delivery
;
const isDeliveryExpress = (method)=>method === ShippingMethod.DeliveryExpress
;
const isNearestPickup = (method)=>method === ShippingMethod.NearestPickup
;
const isPickupStore = (method)=>method === ShippingMethod.Pickup
;
const isPickupPoint = (method)=>method === ShippingMethod.PickupPoint
;
const isDeliveryPremium = (method)=>method === ShippingMethod.DeliveryPremium
;
const isDeliveryResponsible = (method)=>method === ShippingMethod.DeliveryResponsible
;

export { isDelivery, isDeliveryExpress, isDeliveryPremium, isDeliveryResponsible, isNearestPickup, isPickupPoint, isPickupStore };
//# sourceMappingURL=shipping-method.js.map
